<template>
    <div>
        <div id="requireresLoginPage" class="container-fluid">

            <div class="row">
                <div class="col-12" style="margin: 1em; color: #000; text-align:left;">
                    This application must be launched from within Canvas.
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // const settings = require('/ps_settings/config.json');
    export default {
        name: 'RequiresLti',
        components: {
        },
        data() {
            return {
                envVars: process.env,
                store: this.$store
            };
        },
        beforeCreate() {
        },
        methods: {
        },
        mounted: function() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
